import LearningsListScreen from './LearningsListScreen/LearningsListScreen';

export default (props: any) => (
  <LearningsListScreen
    {...props}
    showRecommendations={true}
    fromBriefing={true}
  />
);
